import ProfileView from '../components/Profile/ProfileView';

const styles = {
  container: {
    height: '100%',
    overflowY: 'auto',
  },
};

export default function ProfilePage() {
  return (
    <div style={styles.container}>
      <ProfileView />
    </div>
  );
}
